export default __webpack_public_path__ + "static/media/card-img-1.eea1e6a2.png";